(function() {
    'use strict';

    angular.module('app').factory('Vehicle', ['$http', '$translate', 'toaster', VehicleFactory]);

    function VehicleFactory($http, $translate, toaster) {
        function Vehicle(model) {
            this.id = model.objectId;
            this.model = model;

            /**
             * address
             */
            this.address = {
                show: false,
                detail: null,
                need: true,
                loading: false,
            };

            /**
             * extended
             */
            this.extended = {
                message: null,
                show: false,
                need: true,
                data: {},
            };

            angular.extend(this, model);

            this.setExtendedOptions(model);
        }

        Vehicle.prototype.extend = function(data) {
            var self = this;
            var fields = [
                'distance',
                'workTime',
                'workTimeTxt',
                'groups',
                'average',
                'averageInput',
                'ignitionDateTime',
                'remainingDistance',
                'tachographAlerts',
            ];

            angular.forEach(fields, function(v) {
                if (data[v] !== void 0) {
                    self.extended.data[v] = data[v];
                }
            });

            angular.extend(self, self.extended.data);

            return self;
        };

        Vehicle.prototype.setExtendedOptions = function(data) {
            if (!this.extended.message || Number(data.messageId) !== Number(this.extended.message)) {
                this.extended.need = true;
                this.extended.message = Number(data.messageId);
            }
        };

        Vehicle.prototype.setAdressOptions = function(data) {
            if (data.last !== void 0) {
                if (this.location().y !== data.last.y || this.location().x !== data.last.x) {
                    this.address.detail = null;
                    this.address.need = data.last.y !== 0 || data.last.x !== 0;
                }
            }
        };

        Vehicle.prototype.update = function(model) {
            this.setAdressOptions(model);
            this.setExtendedOptions(model);

            angular.extend(this.model, model);
            angular.extend(this, model);

            this.getAddress();
        };

        /**
         * Check if the object's engine is on
         *
         * @returns {boolean}
         */
        Vehicle.prototype.isEngineOn = function() {
            var model = this.model;

            return model.details.ignition && parseFloat(model.details.ignition.value) === 1;
        };

        /**
         * Check if the object is moving
         *
         * @returns {boolean}
         */
        Vehicle.prototype.isObjectMoving = function() {
            var model = this.model;

            return model.last.speed !== void 0 && model.last.speed > 0 ? true : false;
        };

        /**
         * Get object address
         * We get address only when there is selected object on the map / mobile
         *
         *
         * @param {object} object
         * @returns {promise}
         */
        Vehicle.prototype.getAddress = function() {
            var self = this;

            if (!self.address.need || !self.address.show || self.address.loading) {
                return false;
            }

            var endpoint = '/rest-api/osm/undici';
            var params = {
                lat: this.location().y,
                lon: this.location().x,
                cachable: 1,
            };
            self.address.loading = true;

            return $http
                .get(endpoint, { params: params, displayButterbar: false })
                .then(
                    function(response) {
                        var data = response.data;

                        if (data !== void 0) {
                            self.address.detail = data.display_name;
                            self.address.need = false;
                            self.address.show = true;
                        }
                    },
                    function() {}
                )
                .finally(function() {
                    self.address.loading = false;
                });
        };

        Vehicle.prototype.edit = function(id, form) {
            return $http.put(`/rest-api/vehicle/${id}`, form).then(
                function() {
                    toaster.pop(
                        'success',
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant('general.toastr.success.form.action.update')
                    );
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('general.toastr.error.form.action.update')
                    );
                }
            );
        };

        Vehicle.prototype.getDrivers = function() {
            var start = moment()
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
            var end = moment()
                .endOf('day')
                .format('YYYY-MM-DD HH:mm:ss');

            var params = {
                object: this.id,
                start: start,
                end: end,
            };

            return $http.get('/api/node/object/tachograph-drivers', { params: params }).then(
                function(response) {
                    var drivers = (response.data || {}).data;
                    if (drivers !== void 0) {
                        return drivers;
                    }
                    return [];
                },
                function() {
                    return [];
                }
            );
        };

        /**
         * Getter function
         */
        Vehicle.prototype.get = function(key) {
            return this.model[key];
        };

        /**
         * Getter function
         */
        Vehicle.prototype.location = function() {
            return this.model.last;
        };

        return Vehicle;
    }
})();
